const mockTeamBoostCalendar = [
  {
    id: "tb-1",
    machineId: "V20-6450",
    startDate: "2026-02-24",
    endDate: "2026-02-24",
    extraTeams: 1,
    notes: "2 equipes no mesmo dia para backlog",
  },
  {
    id: "tb-2",
    machineId: "V26-6336",
    startDate: "2026-03-03",
    endDate: "2026-03-04",
    extraTeams: 1,
    notes: "Reforco programado",
  },
];

export default mockTeamBoostCalendar;
